import { Map } from 'immutable';
import {
    GET_TOKENS,
    GET_CONTACTDETAILS,
    GET_CLIENTDETAILS,
    USER_LOGOUT,
    GET_CAPTCHA,
} from '../actions/auth';


const initialState = Map({
    dataFromMic:'',
    contactDetails:'',
    clientDetails:'',
    countries:'',
    captchaValue:'',
});

const actionsMap = {
  [GET_TOKENS]: (state, action) => {
    return state.set('dataFromMic', action.dataFromMic);
  },
  [GET_CONTACTDETAILS]: (state, action) => {
    return state.set('contactDetails', action.contactDetails);
  },
  [GET_CLIENTDETAILS]: (state, action) => {
    return state.set('clientDetails', action.clientDetails);
  },
  [USER_LOGOUT]: (state, action) => {
    sessionStorage.clear()
    action = undefined;
    return state;
  },
  [GET_CAPTCHA]: (state, action) => {
    return state.set('captchaValue', action.captchaValue);
  }
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
